import { stripKerningOverridesHTML } from "./stripKerningOverridesHTML";

// True when prev and next differ ONLY in their kerning span markup. Used by
// UncontrolledContentEditable to detect kerning-preview prop updates that need
// an in-place innerHTML rewrite (with caret restore) rather than waiting for
// React to reconcile.
export const isKerningOnlyChange = (prev: string, next: string): boolean => {
  if (prev === next) return false;
  return stripKerningOverridesHTML(prev) === stripKerningOverridesHTML(next);
};
